import Vue from "vue";
import CompanyService from "@/service/CompanyService";
import MenuRightSerivce from "@/service/MenuRightService";
import SweetAlertService from "@/service/SweetAlertService";
import StoreGetter from "@/constants/StoreGetter";
import { Company } from "@/model/Company";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import companyValidationObj from "./S081000-CompanyValidation.js";
import Paginate from "vuejs-paginate";
import Settings from "../../../constants/Settings.js";
var companyDataValidationObj = new companyValidationObj();
export default {
  name: "Company",
  mounted() {
    companyDataValidationObj.companyValidation();
    this.assignRights();
    this.resetComapny();
    this.init();
    this.getAllCompany();
  },
  components: {
    paginate: Paginate,
  },
  data: () => ({
    menuRights: { allRights: {}, rightsForThisMenu: {} },
    menuId: Settings.MenuID.S_Company,
    Settings: Settings,
    dictEnum: dictEnum,
    company: new Company(),
    isEditMode: false,
    companyList: [],
    selectAllCompany: false,
    tempCompanyModel: new Company(),
    take: 10,
    skip: 0,
    totalNoOfPages: 0,
    noOfPages: 5,
    currentSelectedPage: 0,
    currentPage: 1,
    totalRecords: 0,
  }),
  computed: {
    t() {
      return t;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    },
  },
  methods: {
    init() {
      var self = this;
      var documentHeight = $(document).height();
      var headerHeight = $("nav").height();
      var tabHeight = $(".tab-header-section").height();
      var tableHeaderHeight = $(".comp-table table thead").height();
      var pagginationHeight = $(".paggination-company").height();
      var docHeight = documentHeight != undefined ? documentHeight : 666;
      var headHeight = headerHeight != undefined ? headerHeight : 59;
      var tabHeaderHeight = tabHeight != undefined ? tabHeight : 36;
      var tHeadHeight = tableHeaderHeight != undefined && tableHeaderHeight != 0 ? tableHeaderHeight : 58;
      var paggHeight = pagginationHeight != undefined && pagginationHeight != 0 ? pagginationHeight : 22;
      var tableHeight = docHeight - headHeight - tabHeaderHeight - tHeadHeight - paggHeight - 70;
      self.take = Number((tableHeight / 39).toFixed());
    },
    hasRight(key, menuId) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },
    async getAllCompany() {
      var self = this;
      var obj = {
        take: self.take,
        skip: self.skip,
      }
      const response = await CompanyService.getAllCompanyList(obj);
      if (response.data.IsSuccess) {
        self.companyList = response.data.Data.Item1;
        self.totalRecords = response.data.Data.Item2;
        self.totalPages();
        if (response.data.Data.Item1.length == 0 && response.data.Data.Item2 > 0) {
          self.changepage(self.currentpage - 1);
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getCompanyDetail() {
      var self = this;
      const obj = {
        companyCode: self.tempCompanyModel.CompCode
      };
      const response = await CompanyService.getCompanyDetail(obj);
      if (response.data.IsSuccess) {
        self.company = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    selectAllCompanyRecord: function () {
      var self = this;
      var IsSelected = self.selectAllCompany;
      self.companyList.forEach(function (val, index) {
        val["isSelected"] = IsSelected;
      });
    },
    deleteMultipleCompanyPopup: function () {
      var arrayList = [];
      var self = this;
      self.companyList.forEach(function (key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      if (arrayList.length > 0) {
        $('#deleteCompanyModel').modal('show');
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectDeleteRecord));
      }
    },
    async deleteMultipleCompany() {
      var arrayList = [];
      var self = this;
      $('#deleteCompanyModel').modal('hide');
      self.companyList.forEach(function (key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      const obj = {
        companyList: arrayList,
      };
      const response = await CompanyService.deleteCompany(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetComapny();
        self.init();
        await self.getAllCompany();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    OnCompanySelect: function (model) {
      this.tempCompanyModel = model;
    },
    addCompany: function () {
      var self = this;
      $('#companyModel').modal('show');
      self.isEditMode = false;
      self.company = new Company();
      self.$validator.reset();
      self.vErrors.clear();
    },
    async saveCompanyDetail(obj) {
      var self = this;
      const response = await CompanyService.addCompany(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetComapny();
        self.init();
        await self.getAllCompany();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async editCompany(obj) {
      var self = this;
      const response = await CompanyService.updateCompany(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetComapny();
        self.init();
        await self.getAllCompany();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async saveCompany() {
      var self = this;
      self.$validator.validateAll().then(result => {
        if (result) {
          $('#companyModel').modal('hide');
          const obj = {
            model: {
              CompCode: self.company.CompCode,
              CName: self.company.CName,
              EName: self.company.EName,
              Photo: self.company.Photo,
              PhotoFile: self.company.PhotoFile,
              LetterHead: self.company.LetterHead,
              AddBy: self.$store.getters[StoreGetter.user].UserID,
              ModifyBy: self.$store.getters[StoreGetter.user].UserID
            }
          };
          if (self.isEditMode) {
            self.editCompany(obj);
          }
          else {
            self.saveCompanyDetail(obj);
          }
        }
      });
    },
    async editCompanyDetail() {
      var self = this;
      self.isEditMode = true;
      if (self.tempCompanyModel.CompCode != "") {
        await self.getCompanyDetail();
        self.$validator.reset();
        self.vErrors.clear();
        $('#companyModel').modal('show');
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectEditRecord));
      }
    },
    resetComapny: function () {
      var self = this;
      self.selectAllCompany = false;
      self.isEditMode = false;
      self.company = new Company();
      self.tempCompanyModel = new Company();
      self.$validator.reset();
      self.vErrors.clear();
      self.take = 10;
      self.skip = 0;
      self.totalNoOfPages = 0;
      self.noOfPages = 5;
      self.currentSelectedPage = 0;
      self.currentPage = 1;
      self.totalRecords = 0;
    },
    closeComapnyPopup: function () {
      var self = this;
      self.selectAllCompany = false;
      self.isEditMode = false;
      self.company = new Company();
      self.tempCompanyModel = new Company();
      self.$validator.reset();
      self.vErrors.clear();
      $('#companyModel').modal('hide');
    },
    onPhotoChange(payload) {
      var self = this;
      var file = payload; // in case vuetify file input
      const reader = new FileReader();
      reader.addEventListener(
        "load",
        function () {
          var image = new Image();
          image.src = reader.result ? reader.result.toString() : "";
          image.onload = function () {
            var path = reader.result ? reader.result.toString() : "";
            self.company.Photo = path;
            self.company.PhotoFile = path.indexOf(",") != -1 ? path.split(",").pop() : "";
          };
        },
        false
      );

      if (file) {
        reader.readAsDataURL(file);
      }
    },
    OnPhotoOpen: function () {
      var self = this;
      $("#companyImage").click();
    },
    //Pagination Method start
    changePage(pagenumber) {
      this.currentPage = pagenumber;
      this.setPage();
    },
    setPage() {
      this.skip = this.take * (this.currentPage - 1);
      this.getAllCompany();
    },
    totalPages() {
      var numbers = this.totalRecords / this.take;
      var pages = 0;
      if (Number.isInteger(numbers)) {
        pages = numbers;
      } else {
        pages = Math.floor(numbers) + 1;
      }
      this.totalNoOfPages = pages;
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/S080000-Setup/S081000-Company/S081000-Company.js